import {
    getTypeAbsenteeismService
    , getAbsenceSenderService
    , getEmployeesService
    , getDiagnosticGroupsService
    , getTimeOfAbsenceService
} from '@/services/health-tracker/absenteeism/V2/information-management/graphics/service'

import {
    getAbsenteeismTotalRecordedService
} from '@/services/health-tracker/absenteeism/service'

const state = () => ({
    typesAbsenteeism: []
    , absenceSenders: []
    , typesAbsenteeismEmployees: []
    , diagnosticGroupsEmployees: []
    , diagnosticGroups: []
    , totalRecorded: 0
    , lost_times: []
})

const mutations = {
    SET_TYPE_ABSENTEEISM (state, typesAbsenteeism = [])
    {
        state.typesAbsenteeism = typesAbsenteeism
    }
    , SET_ABSENCE_SENDER (state, absenceSenders = [])
    {
        state.absenceSenders = absenceSenders
    }
    , SET_TYPE_ABSENTEEISM_EMPLOYEES (state, employees = [])
    {
        state.typesAbsenteeismEmployees = employees
    }
    , SET_TOTAL_RECORDED (state, total)
    {
        state.totalRecorded = total
    }
    , SET_DIAGNOSTIC_GROUP (state, diagnosticGroups = [])
    {
        state.diagnosticGroups = diagnosticGroups
    }
    , SET_DIAGNOSTIC_GROUP_EMPLOYEE (state, employees = [])
    {
        state.diagnosticGroupsEmployees = employees
    }
    , SET_LOST_TIMES (state, lost_times = []) {
        state.lost_times = lost_times
    }
}

const actions = {
    async getTypeAbsenteeismStore ({ commit }, data = {})
    {
        commit('SET_TYPE_ABSENTEEISM_EMPLOYEES')
        const { result } = await getTypeAbsenteeismService(data)
        commit('SET_TYPE_ABSENTEEISM', result)
    }
    , async getAbsenceSenderStore ({ commit }, data = {})
    {
        const { result } = await getAbsenceSenderService(data)
        commit('SET_ABSENCE_SENDER', result)
    }
    , async getEmployeesStore ({ commit }, { data = {}, type = ''})
    {
       const values = {
           'type-of-absenteeism' : 'SET_TYPE_ABSENTEEISM_EMPLOYEES'
           ,'diagnostic-groups': 'SET_DIAGNOSTIC_GROUP_EMPLOYEE'
       }
       if (
           values[type]
       ) {
            data.type = type
            const { result } = await getEmployeesService(data)
            commit(values[type], result)
       }
    }
    , async getAbsenteeismTotalRecordedStore ({ commit })
    {
        const { result } = await getAbsenteeismTotalRecordedService()
        commit('SET_TOTAL_RECORDED', result)
    }

    , async getDiagnosticGroupsStore ({ commit }, data = {})
    {
        commit('SET_DIAGNOSTIC_GROUP_EMPLOYEE')
        const { result } = await getDiagnosticGroupsService(data)
        commit('SET_DIAGNOSTIC_GROUP', result)
    }
    , async getLostTimeStore ({ commit }, data = {})
    {
        const { result } = await getTimeOfAbsenceService(data)
        commit('SET_LOST_TIMES', result)
    }
}
const getters = {
    getTypesAbsenteeism : (state) => { return state.typesAbsenteeism }
    , getAbsenceSenders : (state) => { return state.absenceSenders }
    , getTypesAbsenteeismEmployees : (state) => { return state.typesAbsenteeismEmployees }
    , getTotalRecorded : (state) => { return state.totalRecorded }
    , getDiagnosticGroups : (state) => { return state.diagnosticGroups }
    , getDiagnosticGroupEmployees : (state) => { return state.diagnosticGroupsEmployees }
    , getLostTimes : (state) => { return state.lost_times }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}